import React, { useEffect, useMemo } from 'react';
import Modal from '../../BaseComponents/Modal';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../BaseComponents/Loader';
import { RootState } from '../../../store/store';
import Select from '../../BaseComponents/Select';
import Button from '../../BaseComponents/Button';
import './MemberInfoCard.scss';
import { getDoctorsList } from '../../../api/doctors';
import { setDoctorsList } from '../../../store/doctorsSlice';
import { assignDoctorToMember } from '../../../api/members';
import { setMemberData } from '../../../store/memberSlice';

type AssignDoctorModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const AssignDoctorModal: React.FC<AssignDoctorModalProps> = ({
  isOpen,
  onClose
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<boolean>(false);
  const [selectedOption, setSelectedOption] = React.useState<any>(false);

  const { doctorsList } = useSelector((state: RootState) => state.doctors);
  const { memberData, assignedDoctorId } = useSelector(
    (state: RootState) => state.member
  );

  useEffect(() => {
    const fetchClinics = async () => {
      try {
        setLoading(true);
        const doctorsList = await getDoctorsList(0, 1000);
        dispatch(setDoctorsList(doctorsList.doctors));

        if (assignedDoctorId && doctorsList.doctors) {
          const assigned = doctorsList.doctors.find(
            (doctor) => doctor.id === assignedDoctorId
          );
          if (assigned) {
            setSelectedOption({
              key: assigned.id,
              value: `${assigned.first_name} ${assigned.last_name}`
            });
          }
        }
      } catch (error) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchClinics();
  }, [assignedDoctorId, dispatch]);

  const doctorsListOptions = useMemo(() => {
    return doctorsList
      ? doctorsList.map((doctor) => ({
          key: doctor.id,
          value: `${doctor.first_name} ${doctor.last_name}`
        }))
      : [];
  }, [doctorsList]);

  const onAssignClick = async () => {
    try {
      setLoading(true);
      await assignDoctorToMember({
        doctor_id: selectedOption.key,
        member_id: memberData?.user_id!
      });
      const selectedDoctor = doctorsList?.find(
        (doctor) => doctor.id === selectedOption.key
      );

      if (selectedDoctor && memberData) {
        dispatch(
          setMemberData({
            ...memberData,
            doctor: {
              first_name: selectedDoctor.first_name,
              last_name: selectedDoctor.last_name,
              photo_url: selectedDoctor.photo_url,
              user_id: selectedDoctor.id
            }
          })
        );
      }

      onClose();
    } catch (error) {
      console.log('error assigning doctor', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;
  if (error) return <div>Error fetching doctors list</div>;

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={'400px'}>
      <div className='assign-doctor-modal'>
        <div className='assign-header'>Please select doctor to assign:</div>
        <div className='select-doctor-container'>
          <Select
            name='doctor'
            placeholder='Select doctor'
            options={doctorsListOptions}
            selectedOption={selectedOption}
            onChange={(option) => setSelectedOption(option)}
            isError={false}
          />
        </div>

        <div className='submit-btn-wrapper'>
          <Button text='Assign' onClick={onAssignClick} isLoading={loading} />
          <Button
            isLoading={loading}
            text='Cancel'
            onClick={onClose}
            backgroundColor={'#ffffff'}
            color={'#2D334E'}
          />
        </div>
        {error && (
          <div className='error-message'>
            Something went wrong. Please try again later
          </div>
        )}
      </div>
    </Modal>
  );
};
export default AssignDoctorModal;
